import service from "./fetchInterceptor";

/**
 * Obtiene una imagen de documento
 */
export function getImage(imageId) {
  return service.get(`/parse-docs/image/${imageId}`, {
    responseType: "blob",
  });
}

/**
 * Sube un archivo (multipart)
 */
export function upload(action, fmData) {
  return service.post(action, fmData, {
    headers: { "content-type": "multipart/form-data" },
  });
}

/**
 * Obtiene código de fondo
 */
export function backgroundCode(invoice, verification, cartransferId) {
  return service.get(`/parse-docs/background-code`, {
    params: { cartransferId, verification, invoice },
  });
}

/**
 * Obtiene código de fondo desde imagen
 */
export function bgCodeFromImg(action, fmData) {
  return service.post(`/parse-docs/${action}`, fmData, {
    headers: { "content-type": "multipart/form-data" },
  });
}

/**
 * Rutificador
 */
export function fetchRutificador(rut) {
  return service.get(`/parse-docs/ci-rutificador`, {
    params: { rut },
  });
}
